// @flow

import type {
  VbmrState,
  VbmrModalType,
} from './types';
import type {
  State as ConfigurationState,
} from '../types';
import {
  VBMR_MODAL_TYPE_ACTIVATE,
  VBMR_MODAL_TYPE_DEACTIVATE,
} from './constants';
import {
  getActivateTitle,
  getActivateDescription,
  getActivateAcceptButtonText,
  getActivateDeclineButtonText,
  getDeactivateTitle,
  getDeactivateDescription,
  getDeactivateAcceptButtonText,
  getDeactivateDeclineButtonText,
  getShowActivateOverlay,
  getShowDeactivateOverlay,
} from '../../configuratorSettings/selectors/vbmr';

type GlobalState = {
  configuration: ConfigurationState,
  configuratorSettings: any,
};

export const getReducer = (state: GlobalState): VbmrState => state.configuration.vbmr;

export const getIsShowingModal = (state: GlobalState): boolean => (
  getReducer(state).isShowingModal
);

export const getModalType = (state: GlobalState): ?VbmrModalType => (
  getReducer(state).modalType
);

export const getSection = (state: GlobalState): string => (
  getReducer(state).section
);

export const getIsActive = (state: GlobalState): boolean => (
  getReducer(state).isActive
);

export const getIsInitialized = (state: GlobalState): boolean => (
  getReducer(state).isInitialized
);

export const getModalTitle = (state: GlobalState): string => {
  if (getModalType(state) === VBMR_MODAL_TYPE_ACTIVATE) {
    return getActivateTitle(state);
  } if (getModalType(state) === VBMR_MODAL_TYPE_DEACTIVATE) {
    return getDeactivateTitle(state);
  }
  return '';
};

export const getModalDescription = (state: GlobalState): string => {
  if (getModalType(state) === VBMR_MODAL_TYPE_ACTIVATE) {
    return getActivateDescription(state);
  } if (getModalType(state) === VBMR_MODAL_TYPE_DEACTIVATE) {
    return getDeactivateDescription(state);
  }
  return '';
};

export const getModalAcceptButtonText = (state: GlobalState): string => {
  if (getModalType(state) === VBMR_MODAL_TYPE_ACTIVATE) {
    return getActivateAcceptButtonText(state);
  } if (getModalType(state) === VBMR_MODAL_TYPE_DEACTIVATE) {
    return getDeactivateAcceptButtonText(state);
  }
  return '';
};

export const getModalDeclineButtonText = (state: GlobalState): string => {
  if (getModalType(state) === VBMR_MODAL_TYPE_ACTIVATE) {
    return getActivateDeclineButtonText(state);
  } if (getModalType(state) === VBMR_MODAL_TYPE_DEACTIVATE) {
    return getDeactivateDeclineButtonText(state);
  }
  return '';
};

export const getIsVbmrEnabled = (state: GlobalState): boolean => (
  getReducer(state).isActive
);

export const getActivateModalTimesTriggered = (state: GlobalState): number => (
  getReducer(state).activateModalTimesTriggered
);

export const getDeactivateModalTimesTriggered = (state: GlobalState): number => (
  getReducer(state).deactivateModalTimesTriggered
);

export const getAllowedTimesOfDisplayingModal = (
  state: GlobalState,
  modalType: VbmrModalType,
): number => (modalType === VBMR_MODAL_TYPE_ACTIVATE ? getShowActivateOverlay(state)
  : getShowDeactivateOverlay(state));

export const getTimesOfDisplayedModal = (
  state: GlobalState,
  modalType: VbmrModalType,
): number => (modalType === VBMR_MODAL_TYPE_ACTIVATE ? getActivateModalTimesTriggered(state)
  : getDeactivateModalTimesTriggered(state));

export default null;
